import styles from './MainBanner.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import SwiperCore from 'swiper';
import { useState } from 'react';
import banner3 from '../../assets/banner/mainBanner03.jpg';
import banner4 from '../../assets/banner/mainBanner04.jpg';
import banner5 from '../../assets/banner/mainBanner05.png';
import banner6 from '../../assets/banner/mainBanner06.png';
import banner7 from '../../assets/banner/mainBanner07.jpg';
import banner8 from '../../assets/banner/mainBanner08.png';

import { useNavigate } from 'react-router-dom';
import { checkRequired } from '../../common/checkRequired';
import axiosClient from '../../libs/axiosClient';
import { useQuery } from 'react-query';
// Fallback banner data
const defaultBannerList: IBannerType[] = [
  { image: banner7, url: 'productDetail/136' },
  { image: banner6, url: 'productDetail/116' },
  { image: banner8, url: 'productDetail/133' },
  { image: banner3, url: 'event/22' },
  { image: banner5, url: 'event/24' },
  { image: banner4, url: 'event/23' },
];

export interface IBannerType {
  image: string;
  url?: string;
}
function MainBanner() {
  const [activeIdx, setActiveIdx] = useState(0);
  const [swiper, setSwiper] = useState<SwiperCore>();
  const navigate = useNavigate();

  // Fetch banner data from API
  const { data: apiBannerData = [] } = useQuery<IBannerType[]>(
    'banner-advertisement',
    async () => {
      return await axiosClient
        .get('/data/banner/advertisement')
        .then((res) => 
          res.data.map((banner: any) => ({
            image: banner.image,
            url: banner.link
          }))
        );
    },
    {
      staleTime: 60000 * 60, // 1 hour cache
    }
  );

  // Use API data if available and not empty, otherwise use default banners
  const slideList = apiBannerData.length > 0 ? apiBannerData : defaultBannerList;
  return (
    <div className={styles.container}>
      <div className={styles.bannerSliderWrap}>
        <Swiper
          onSwiper={setSwiper}
          slidesPerView={1}
          spaceBetween={0}
          className={styles.bannerSlider}
          onSlideChange={(e) => setActiveIdx(e.activeIndex)}
        >
          {slideList.map((slide, idx) => (
            <SwiperSlide
              key={idx}
              onClick={() => {
                if (slide.url) navigate(slide.url);
              }}
            >
              <img
                src={slide.image}
                alt="banner"
                style={{ cursor: slide.url ? 'pointer' : 'unset' }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <ul className={styles.paginationWrap}>
          {slideList.map((banner, idx) => (
            <li
              key={idx}
              onClick={() => swiper?.slideTo(idx, 200)}
              className={idx == activeIdx ? styles.hit : ''}
            ></li>
          ))}
        </ul>
      </div>
    </div>
  );
}
export default MainBanner;
